// Display-only formatting helpers. Never mutate stored data with these —
// names are persisted exactly as entered/imported; this only affects how
// they render in the UI.
/** "AVRUMI KLEIN" / "avrumi klein" -> "Avrumi Klein". Handles hyphens and
 * multi-word names (e.g. "jean-baptiste van de velde" -> "Jean-Baptiste Van De Velde"). */
export const toTitleCase = (value) => {
    if (!value)
        return '';
    return value
        .toLowerCase()
        .split(' ')
        .map((word) => word
        .split('-')
        .map((part) => (part ? part[0].toUpperCase() + part.slice(1) : part))
        .join('-'))
        .join(' ');
};
/** Uppercase first letter for avatar initials, regardless of source casing. */
export const initialOf = (value) => value ? value[0].toUpperCase() : '';
